function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styledSystemPropTypes from "@styled-system/prop-types";
import tagComponent from "../../__internal__/utils/helpers/tags/tags";
import StyledLoader from "./loader.style";
import StyledLoaderSquare from "./loader-square.style";
import { filterStyledSystemMarginProps } from "../../style/utils";
const marginPropTypes = filterStyledSystemMarginProps(styledSystemPropTypes.space);

const Loader = ({
  "aria-label": ariaLabel,
  isInsideButton,
  isActive,
  size,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(StyledLoader, _extends({
    "aria-label": ariaLabel,
    role: "progressbar"
  }, tagComponent("loader", rest), rest), /*#__PURE__*/React.createElement(StyledLoaderSquare, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }), /*#__PURE__*/React.createElement(StyledLoaderSquare, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }), /*#__PURE__*/React.createElement(StyledLoaderSquare, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }));
};

Loader.defaultProps = {
  size: "medium",
  isInsideButton: false,
  isActive: true,
  "aria-label": "loader"
};
Loader.propTypes = { ...marginPropTypes,

  /** Specify an aria-label for the Loader component */
  "aria-label": PropTypes.string,

  /** Size of the loader. */
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** Applies white color. */
  isInsideButton: PropTypes.bool,

  /** Applies slate color. Available only when isInsideButton is true. */
  isActive: PropTypes.bool
};
export default Loader;